<template aria-hidden="true">
  <svg
    aria-hidden="true"
    width="175"
    height="131"
    viewBox="0 0 175 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.1219 92.2488L110.427 92.3776C110.842 92.3784 111.247 92.3343 111.636 92.25C112.025 92.3357 112.429 92.3812 112.844 92.3819L154.733 92.4555C157.847 92.461 160.376 89.9408 160.382 86.8265C160.387 83.7123 157.867 81.1832 154.753 81.1777L149.919 81.1692C146.805 81.1638 144.285 78.6347 144.29 75.5205C144.296 72.4062 146.825 69.886 149.939 69.8915L165.245 69.9184C168.359 69.9239 170.888 67.4037 170.893 64.2894C170.899 61.1751 168.379 58.6461 165.265 58.6406L147.542 58.6095C150.657 58.615 153.186 56.0948 153.191 52.9805C153.197 49.8662 150.676 47.3372 147.562 47.3317L96.0067 47.2411C99.1209 47.2466 101.65 44.7264 101.655 41.6122C101.661 38.4979 99.1408 35.9688 96.0265 35.9634L50.1099 35.8827C46.9956 35.8772 44.4666 38.3974 44.4611 41.5117C44.4556 44.6259 46.9758 47.155 50.0901 47.1604L17.8679 47.1038C14.7536 47.0984 12.2246 49.6185 12.2191 52.7328C12.2136 55.8471 14.7338 58.3761 17.8481 58.3816L37.9869 58.417C41.1012 58.4224 43.6214 60.9515 43.6159 64.0658C43.6104 67.18 41.0814 69.7002 37.9671 69.6947L5.74496 69.6381C2.63069 69.6326 0.10164 72.1528 0.096168 75.2671C0.0906957 78.3814 2.61087 80.9104 5.72514 80.9159L37.1418 80.9711C34.0275 80.9656 31.4984 83.4858 31.493 86.6C31.4875 89.7143 34.0077 92.2434 37.1219 92.2488ZM168.427 92.4796C171.542 92.485 174.071 89.9649 174.076 86.8506C174.082 83.7363 171.561 81.2073 168.447 81.2018C165.333 81.1963 162.804 83.7165 162.798 86.8308C162.793 89.945 165.313 92.4741 168.427 92.4796Z"
      fill="#F0F3FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.5765 100.618L49.0582 101.104C47.1672 101.366 45.4215 100.05 45.1592 98.1646L35.6573 29.8955C35.3949 28.0103 36.7151 26.27 38.6062 26.0084L106.23 16.6549C108.121 16.3933 109.867 17.7096 110.129 19.5948C110.129 19.5948 110.737 23.9599 110.945 25.4614"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.7667 96.8227L51.5719 97.2697C49.8548 97.5099 48.2719 96.3171 48.0364 94.6056L39.5075 32.6245C39.2719 30.913 40.473 29.3307 42.1902 29.0905L103.596 20.4996C105.313 20.2594 106.896 21.4522 107.131 23.1637L107.864 28.49C107.904 28.7782 110.522 47.9085 115.719 85.8809C115.98 87.7876 114.658 89.5467 112.767 89.8098C112.747 89.8126 112.726 89.8153 112.706 89.8177L54.7667 96.8227Z"
      fill="#D5DCFD"
    />
    <path
      d="M52.5765 100.618L49.0582 101.104C47.1672 101.366 45.4215 100.05 45.1592 98.1646L35.6573 29.8955C35.3949 28.0103 36.7151 26.27 38.6062 26.0084L106.23 16.6549C108.121 16.3933 109.867 17.7096 110.129 19.5948C110.129 19.5948 110.737 23.9599 110.945 25.4614"
      stroke="#2147F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M111.659 29.4398L112.086 32.1289"
      stroke="#2147F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M67.5921 30.5289L134.397 37.6475C136.181 37.8376 137.473 39.4386 137.282 41.2233L130.053 108.655C129.861 110.44 128.259 111.732 126.475 111.542L59.6702 104.423C57.8854 104.233 56.5936 102.632 56.7849 100.848L64.014 33.4161C64.2053 31.6314 65.8073 30.3387 67.5921 30.5289Z"
      fill="white"
      stroke="#2147F4"
      stroke-width="1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.282 40.8755C70.4586 39.2281 71.9374 38.0349 73.5849 38.2105L126.911 43.8927C128.558 44.0683 129.751 45.5461 129.574 47.1935L124.795 91.7706C124.618 93.418 123.14 94.6111 121.492 94.4356L68.1664 88.7533C66.5189 88.5778 65.3265 87.1 65.5031 85.4525L70.282 40.8755Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.8977 75.4635L80.9937 70.0405C82.6276 68.946 84.814 69.2005 86.1512 70.6408L91.9419 76.8777C92.299 77.2623 92.8928 77.3052 93.3019 76.9759L106.014 66.7439C107.864 65.2552 110.594 65.6942 111.882 67.6872L120.159 80.4996L121.394 82.5625L120.801 89.4196C120.753 89.9801 120.252 90.3906 119.692 90.3277L70.7461 84.8192C70.2046 84.7583 69.8118 84.275 69.8629 83.7325L70.515 76.8054L72.8977 75.4635Z"
      fill="#D5DCFD"
    />
    <path
      d="M73.505 38.9562L126.831 44.6384C128.066 44.7701 128.961 45.8785 128.828 47.114L124.049 91.6911C123.917 92.9266 122.808 93.8215 121.572 93.6899L68.2464 88.0076C67.0107 87.8759 66.1164 86.7676 66.2489 85.532L71.0278 40.955C71.1603 39.7194 72.2693 38.8245 73.505 38.9562Z"
      stroke="#2147F4"
      stroke-width="1.5"
    />
    <ellipse
      cx="5.18501"
      cy="5.16941"
      rx="5.18501"
      ry="5.16941"
      transform="matrix(0.994371 0.105958 -0.106595 0.994303 78.9521 49.1816)"
      fill="#F0F3FF"
      stroke="#2147F4"
      stroke-width="1.5"
    />
    <path
      d="M71.1578 76.7958C74.5637 74.4598 81.3755 69.7878 81.3755 69.7878C82.789 68.841 84.6836 69.0615 85.8403 70.3074L92.028 76.9719C92.3369 77.3045 92.8514 77.3417 93.2051 77.057L106.481 66.3717C107.966 65.1761 110.142 65.4074 111.342 66.8882C111.419 66.9839 111.491 67.0837 111.558 67.1871C111.558 67.1871 119.287 79.461 121.093 82.329"
      stroke="#2147F4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
